export default function AppBar() {
    return (
        <div
            style={{
                fontWeight: 900,
                fontSize: 20,
                padding: '18px 18px',
            }}
        >
            <a href='https://twitter.com/MerchandiseBot' style={{ textDecoration: 'none', color: 'black' }}>
                @MerchandiseBot
            </a>
        </div>
    );
}
